import { createTheme } from '@mui/material';
import {
  DISABLED,
  HIGH_EMPHASIS,
  MEDIUM_EMPHASIS,
  MUI_PRIMARY_MAIN,
  MUI_SECONDARY_MAIN,
  BASIC_BORDER_RADIUS,
  BASIC_GAP,
  TABLE_ODD_ROW_BACKGROUND_COLOR,
} from './tokens';

export const aveda = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: MUI_PRIMARY_MAIN,
    },
    secondary: {
      main: MUI_SECONDARY_MAIN,
    },
    text: {
      primary: HIGH_EMPHASIS,
      secondary: MEDIUM_EMPHASIS,
      disabled: DISABLED,
    },
  },
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd):not(.MuiTableRow-head)': {
            backgroundColor: TABLE_ODD_ROW_BACKGROUND_COLOR,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px 16px',
          fontSize: '16px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: BASIC_BORDER_RADIUS,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: BASIC_BORDER_RADIUS,
          boxShadow: 'none',
        },
        outlined: {
          border: '1px solid rgba(0,0,0,0.12)',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          borderRadius: BASIC_BORDER_RADIUS,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: BASIC_BORDER_RADIUS,
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          flexDirection: 'row',
          alignItems: 'center',
          gap: BASIC_GAP,
        },
      },
    },
  },
});
